import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { Owner, ParentNodesResult, Domain } from '../../../../types.generated';
import DefaultPreviewCard from '../../../preview/DefaultPreviewCard';
import { useEntityRegistry } from '../../../useEntityRegistry';
import utilService from '../../../../utils/util.service';

export const Preview = ({
    urn,
    name,
    description,
    owners,
    domain,
    parentNodes,
    governanceFlag,
    relationshipType,
    readOnly,
}: {
    urn: string;
    name: string;
    domain?: Domain | undefined;
    description?: string | null;
    relationshipType?: string;
    owners?: Array<Owner> | null;
    parentNodes?: ParentNodesResult | null;
    governanceFlag?: any;
    readOnly?: boolean;
}): JSX.Element => {
    const entityRegistry = useEntityRegistry();

    // If the relationship type is isTypeOf i.e. Has Type, then we use the glossary term type, otherwise we use the glossary node type
    const glossaryType = utilService.getEntityTypeFromUrn(urn);

    const entityName = entityRegistry.getEntityName(glossaryType);

    return (
        <DefaultPreviewCard
            url={entityRegistry.getEntityUrl(glossaryType, urn)}
            name={name || ''}
            urn={urn}
            domain={domain}
            relationshipType={relationshipType}
            description={description || ''}
            governanceFlag={governanceFlag}
            owners={owners}
            logoComponent={<FolderOutlined style={{ fontSize: '20px' }} />}
            type={entityName}
            parentEntities={parentNodes?.nodes}
            readOnly={readOnly}
        />
    );
};
